import {useMemo} from 'react';
import config from "../utils/config";

export default function useConfig() {
    return useMemo(() => config, []);
}
